import { getRequest } from '../services/requestHandler';
import { PlayerForSaveDto } from '../models';

// The API returns all players if both fields are null otherwise filters by either or both fields, returns active players only
export const getPlayersWithTourAndBioV2 = async (modifiedAfter?: string) => {
  // Need to build the url around the API which throws an error on a null modifiedAfter after param
  const url = modifiedAfter ? `player/getPlayersWithTourAndBioV2?modifiedAfter=${modifiedAfter}` : 'player/getPlayersWithTourAndBioV2';
  let response = await getRequest<PlayerForSaveDto>('GetPlayersWithTourAndBioV2', url);
  return response;
};
